module.exports = __webpack_public_path__ + "resources/e7fc178699c482ca82b6b9de1af1bf4a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/equipmenttransformed.png
// module id = 209
// module chunks = 0